/**
 * Audio Utilities
 *
 * Helper functions for audio file processing.
 */

/**
 * Extract duration from an audio file using the HTML5 Audio element.
 * @param file - Audio file to analyze
 * @returns Duration in seconds, or 0 if duration cannot be determined
 */
export async function extractAudioDuration(file: File): Promise<number> {
  return new Promise((resolve, reject) => {
    const audio = new Audio();
    const objectUrl = URL.createObjectURL(file);

    audio.src = objectUrl;

    audio.onloadedmetadata = () => {
      URL.revokeObjectURL(objectUrl);
      if (isFinite(audio.duration) && audio.duration > 0) {
        resolve(audio.duration);
      } else {
        resolve(0); // Unknown duration
      }
    };

    audio.onerror = () => {
      URL.revokeObjectURL(objectUrl);
      reject(new Error("Failed to load audio metadata"));
    };
  });
}
